export default "__VITE_ASSET__C0l4X2ZD__"